var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFamilyRestaurant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5455",
    "data-name": "Group 5455",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.75,
    height: 23.686,
    viewBox: "0 0 16.75 23.686",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M14.3,2.453A8.366,8.366,0,0,0,1.1,12.495c.006.015.013.03.02.044L7.933,23.42a.5.5,0,0,0,.885,0l6.814-10.881a.446.446,0,0,0,.022-.05A8.336,8.336,0,0,0,14.3,2.453",
    fill: "#334A7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M7.534,7.6h-.96V4.244h-.96V7.6h-.96V4.244h-.96V7.6a1.914,1.914,0,0,0,1.8,1.906v4.334h1.2V9.51A1.914,1.914,0,0,0,8.494,7.6V4.244h-.96Zm2.4-1.44V10h1.2v3.84h1.2v-9.6a2.371,2.371,0,0,0-2.4,1.92",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyRestaurant);
export default __webpack_public_path__ + "static/media/family-restaurant.7ea5076516bee99e146b2d8fbf1bd531.svg";
export { ForwardRef as ReactComponent };